<template>
	<div>
		<action-sidebar
			:title="title"
			:value="true"
			:width="400"
			@close-modal="closeModal"
		>
			<accounting-period-activate-form
				:code="code"
				:subsidiary-id="subsidiaryId"
				@on-close="closeModal"
			/>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import accountingPeriodActivateForm from '@/components/accounting-periods/accounting-period-activate-form';

function closeModal() {
	this.goTo(
		'accounting-periods',
		{
			params: {
				subsidiaryId: this.subsidiaryId,
				subsidiaryName: this.subsidiaryName,
			},
		},
	);
}

function title() {
	const module = 'Periodo Contable';
	const openOrClose = this.code === 'open' ? `Abrir ${module}` : `Cerrar ${module}`;
	return this.code === 'active' ? `Activar ${module}` : openOrClose;
}

export default {
	name: 'page-accounting-edit',
	components: {
		actionSidebar,
		accountingPeriodActivateForm,
	},
	computed: {
		title,
	},
	methods: {
		closeModal,
	},
	props: {
		code: String,
		subsidiaryId: [Number, String],
		subsidiaryName: String,
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/accounting-periods/page-accounting-period-activate.vue